<template>
  <settings-modal
    class="payment-force-to-auto-swift-modal t-payment-force-to-auto-swift-modal"
  >
    <template slot="heading">{{ heading }}</template>

    <error-alert :error="error" />

    <template slot="actions">
      <v-btn
        class="t-confirm-button"
        color="primary"
        medium
        flat
        :disabled="loading"
        @click="onConfirmButtonClick"
      >confirm</v-btn>

      <v-btn
        class="t-close-button"
        color="primary"
        medium
        flat
        @click="onCloseButtonClick"
      >close</v-btn>
    </template>
  </settings-modal>
</template>

<script>
  import { mapGetters, mapActions } from 'vuex'

  // Events
  import { EVENT_PAYMENT_UPDATE } from '@/events/payments'

  // Services
  import ApiRequest from '@/services/ApiRequests/ApiRequest'
  import PaymentApi from '@/services/Api/PaymentApi'

  // Components
  import SettingsModal from '@/components/modals/SettingsModal'
  import ErrorAlert from '@/components/ui/ErrorAlert'

  export default {
    name: 'PaymentForceToAutoSwiftModal',
    components: {
      SettingsModal,
      ErrorAlert
    },
    data () {
      return {
        paymentForceToAutoSwiftApiRequest: new ApiRequest(PaymentApi.forceToAutoSwift)
      }
    },
    computed: {
      ...mapGetters('modal', ['modal']),
      paymentId () {
        return this.modal.data.paymentId
      },
      heading () {
        return `Force payment ${this.paymentId} send via FIN?`
      },
      loading () {
        return this.paymentForceToAutoSwiftApiRequest.loading
      },
      error () {
        return this.paymentForceToAutoSwiftApiRequest.error
      }
    },
    methods: {
      ...mapActions('modal', ['showModal', 'closeModal']),
      onConfirmButtonClick () {
        this.forcePaymentToFin(this.paymentId)
          .then(() => {
            this.$eventHub.$emit(EVENT_PAYMENT_UPDATE)
            this.closeModal()

            setTimeout(() => {
              this.showModal({
                name: 'SuccessFlashModal',
                data: { message: 'Payment has been successfully updated.' }
              })
            }, 100)
          })
          .catch(() => {})
      },
      forcePaymentToFin (paymentId) {
        return this.paymentForceToAutoSwiftApiRequest.execute(paymentId)
      },
      onCloseButtonClick () {
        this.closeModal()
      }
    }
  }
</script>
